import { render, staticRenderFns } from "./dispatchedMaster.vue?vue&type=template&id=a47d809c&scoped=true"
import script from "./dispatchedMaster.vue?vue&type=script&lang=js"
export * from "./dispatchedMaster.vue?vue&type=script&lang=js"
import style0 from "./dispatchedMaster.vue?vue&type=style&index=0&id=a47d809c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47d809c",
  null
  
)

export default component.exports